import { omit } from 'lodash-es';
import callRecursive from 'utils/callRecursive.js';

export function removeTempId(value) {
  if (value && value.id && typeof value.id === 'string' && value.id.startsWith('tmp_')) {
    return omit(value, ['id']);
  }
  return value;
}

export function removeTempIds(obj) {
  return callRecursive(obj, removeTempId);
}
